namespace Areas {
    "use strict";

    export function buildCellContent(cellElement: any, getData: () => string, contentTemplate: string) {
        const data = getData();
        const re = /{placeholder}/gi;
        const content = contentTemplate.replace(re, data);
        cellElement.html(content);
    }

    export function gotoSelected(gridName: string, url: string) {
        const dataGrid = $(`#${gridName}`).dxDataGrid("instance");
        const dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            location.href = url + dataId;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }


    export function refreshGrid(id: string) {
        $(`#${id}`).dxDataGrid("instance").refresh();
    }     
}